import React from 'react'
import { Breadcrumbs, MetaSeo } from '../..'
import Trans from '../../atoms/Trans/Trans'

const OrdiniImportiTaylorMadeTemplate = ({ page }) => {
  return (
    <div className="ordini_template">
      <MetaSeo seo={page.seo} />
      <Breadcrumbs breadcrumbs={page.breadcrumbs} />
      <h1>Ordini Import - Articoli Tailor Made</h1>
      <img src="" className="ordini_template__headerImg" />
      <div className="w-container">
        <div className="ordini_template__container">
          <h3>Aricoli Tailor Made di importazione diretta</h3>
          <p>
            Ordini speciali di importazione diretta,{' '}
            <strong>articoli personalizzati sulla base delle vostre idee ed esigenze.</strong>
            Realizziamo anche articoli che non rientrano nel normale assortimento a catalogo, creati
            ad hoc per soddisfare specifiche esigenze del cliente e personalizzati direttamente in
            fase di produzione. Vuoi importare un prodotto? Sipec ti offre una soluzione chiavi in
            mano <strong>in 3 semplici passagi:</strong>
          </p>
          <br />
          <strong> 1) Selezione il tuo prodotto</strong>
          <p>- dal catalogo/sito Sipec - www.sipec.com -oppure indicaci un prodotto a tua scelta</p>
        </div>
      </div>
    </div>
  )
}

export default OrdiniImportiTaylorMadeTemplate
